(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

  // Check if there is a referrer
  if (document.referrer !== "") {
    // Check if the referrer URL contains the string "collection"
    if (document.referrer.includes("collection")) {
      // Redirect to the homepage
      window.location.href = "/";
    }
  }


  
  } catch(e) { console.error(e); }
})();
})();
